import { Button, Flex, Pill, Text } from '@mantine/core';
import { Link } from '@tanstack/react-router';

import { EvaluationReport } from '@/module/Evaluation/model/EvaluationTypes';

import { Content } from '@/core/components';

import { useCurrentUser } from '@feature/security';

export interface EvaluationHeaderProps {
  evaluation: EvaluationReport;
  hideSummary?: boolean;
}

export function EvaluationHeader({ evaluation, hideSummary }: EvaluationHeaderProps) {
  const { currentRole } = useCurrentUser();
  const hasAccess = ['DEPARTMENT_ADMIN', 'FACULTY_ADMIN', 'UNIVERSITY_ADMIN'].indexOf(currentRole) !== -1;

  return (
    <Content type="full">
      <Flex
        justify="center"
        align="center"
        gap="4px"
      >
        <Text fw="500">{evaluation.title}</Text>
        <Pill bg={evaluation.open ? 'green' : 'red'}>{evaluation.open ? 'Deschisă' : 'Închisă'}</Pill>
      </Flex>
      {hasAccess && !hideSummary && (
        <Flex
          justify="center"
          align="center"
          gap="10px"
        >
          <Button
            component={Link}
            to="department-summary-results"
            size="xs"
          >
            Rezultate centralizate pe departamente
          </Button>
          <Button
            component={Link}
            to="faculty-summary-results"
            size="xs"
          >
            Rezultate centralizate pe facultăți
          </Button>
        </Flex>
      )}
    </Content>
  );
}
